import search from './Search'

const reducers = {
  search,
}

export default reducers
